// extracted by mini-css-extract-plugin
export default {"nav":"NavigationNav_nav__3vBtO","nav__item":"NavigationNav_nav__item__5nhFB"};